// import { createContext, useState, useContext  } from "react";

// export const SearchContext = createContext();

// export const SearchProvider = ({ children }) => {
//   const [searchCity , setSearchCity] = useState("");

//   return (
//     <SearchContext.Provider value={{ searchCity , setSearchCity }}>
//       {children}
//     </SearchContext.Provider>
//   );
// };

// // Custom hook to consume the city context easily
// export const useCity = () => useContext(SearchContext);



import { createContext, useState, useContext } from "react";

// 1. Create and export the Context object directly
export const SearchContext = createContext();

// 2. Export the Provider component
export const SearchProvider = ({ children }) => {
  const [searchCity, setSearchCity] = useState("");

  return (
    <SearchContext.Provider value={{ searchCity, setSearchCity }}>
      {children}
    </SearchContext.Provider>
  );
};

// 3. Custom hook to consume the context easily
export const useCity = () => useContext(SearchContext); 